/**
 *
 *  Yup-es
 *  @description import entry
 *
 *  @author diegoulloao
 *
 */

const es = require("./lib/es")
module.exports = es
